// Decides whether the content gate should display.
// An always-enabled gate shows for everyone, including users signed into the CMS.
// The metering gate shows once the reader hits the page-view threshold, but never
// for users signed into the CMS.
const shouldDisplayGate = ({ gateEnabled, cmsUserSignedIn, meteringThresholdMet }) => (
  Boolean(gateEnabled) || (!cmsUserSignedIn && Boolean(meteringThresholdMet))
);

export default shouldDisplayGate;
